/** @jsx jsx */
import { FC, memo } from "react";
import { jsx } from "theme-ui";

import { ResponsiveCard } from "@/components/ResponsiveCard";

import { Infobox } from "../Infobox";

export interface IInfoboxSectionProps {
  className?: string;
  imgSrc?: string;
  heading?: string;
  description?: string;
}

export const InfoboxSection: FC<IInfoboxSectionProps> = memo(({ imgSrc, heading, description, className }) => {
  return (
    <ResponsiveCard className={className} sx={{ py: [96, 96, 96, 96] }}>
      <Infobox imgSrc={imgSrc} heading={heading} description={description} />
    </ResponsiveCard>
  );
});
